import React from 'react';
import illustration from '../../assets/illustrations/LandingPage/site de vendas V2-10.png'

const OQueEOClubeSection: React.FC = () => {
  return (
    <section className="relative w-full" style={{ backgroundColor: '#d7cdbd' }}>
      <div className="max-w-6xl mx-auto px-6 lg:px-8 pt-14 pb-14">

        {/* Título */}
        <div className="mb-10">
          <h2 className="font-libre italic text-cafe text-4xl lg:text-5xl xl:text-6xl leading-tight">
            O que você encontra aqui?
          </h2>
        </div>

        {/* Linha vermelha divisória */}
        <div className="w-full h-[2px] mb-8" style={{ backgroundColor: '#ea3e23' }} />

        <div className="flex justify-end gap-8 lg:gap-16">

          <div className="w-full md:w-[400px] font-roboto text-cafe text-sm lg:text-[15px] leading-relaxed space-y-4">
            <p>
              Aqui você aprende mais sobre você mesma a partir de um ponto de vista novo: o de uma psicanalista que parte de livros, filmes e músicas pra mostrar como a gente pensa, sente e age.
            </p>
            <p>
              Você escolhe o percurso que quer seguir e vai descobrindo coisas sobre você que nem você sabia que tinham nome e que agora, finalmente, encontram lugar.
            </p>
            <p>
              Aqui eu te ajudo a escutar a voz que já mora dentro de você: a mesma que vai te dar coragem pra você ser, de uma vez, protagonista da sua história.
            </p>
          </div>
        </div>

          {/* Ilustração + círculo FAÇA PARTE */}
           
             <img 
                src={illustration} 
                alt="" 
                className={`hidden lg:block w-[400px] absolute top-[320px]  z-[10]`}
              />
        </div>


    </section>
  );
};

export default OQueEOClubeSection;
